/*
 * @format
 */

export function primary(number = 500, opacity) {
  switch (number) {
    case 50:
      return '#FAFAFA';

    case 100:
      return '#F5F5F5';

    case 200:
      return '#E6E6E6';

    case 300:
      return '#CCCCCC';

    case 400:
      return '#B3B3B3';

    case 500:
      return '#999999';

    case 600:
      return '#808080';

    case 700:
      return '#666666';

    case 800:
      return '#4D4D4D';

    case 900:
      if (opacity) {
        return `rgba(51, 51, 51, ${opacity})`;
      }

      return '#333333';

    case 950:
      if (opacity) {
        return `rgba(24, 24, 24, ${opacity})`;
      }

      return '#181818';

    default:
      return '#999999';
  }
}

export const accent = (number = 500) => {
  switch (number) {
    case 50:
      return '#F4F9E9';

    case 100:
      return '#DFECBC';

    case 200:
      return '#CAE08F';

    case 300:
      return '#B5D462';

    case 400:
      return '#A0C735';

    case 500:
      return '#95C11F';

    case 600:
      return '#779A19';

    case 700:
      return '#597413';

    case 800:
      return '#3C4D0C';

    case 900:
      return '#1E2706';

    case 950:
      return '#0F1303';

    default:
      return '#95C11F';
  }
};

export const success = (number = 500) => {
  switch (number) {
    case 50:
      return '#E7F8F2';

    case 100:
      return '#CFF1E6';

    case 200:
      return '#9FE3CD';

    case 300:
      return '#70D5B3';

    case 400:
      return '#40C79A';

    case 500:
      return '#10B981';

    case 600:
      return '#0D9467';

    case 700:
      return '#0A6F4D';

    case 800:
      return '#064A34';

    case 900:
      return '#03251A';

    case 950:
      return '#02120D';

    default:
      return '#10B981';
  }
};

export const warning = (number = 500) => {
  switch (number) {
    case 50:
      return '#FFF9E6';

    case 100:
      return '#FFF3CD';

    case 200:
      return '#FFE69C';

    case 300:
      return '#FFDA6A';

    case 400:
      return '#FFCD39';

    case 500:
      return '#FFC107';

    case 600:
      return '#CC9A06';

    case 700:
      return '#997404';

    case 800:
      return '#664D03';

    case 850:
      return '#F29304';

    case 900:
      return '#332701';

    case 950:
      return '#191301';

    default:
      return '#FFC107';
  }
};

export const error = (number = 500) => {
  switch (number) {
    case 50:
      return '#FEF2F2';

    case 100:
      return '#FEE2E2';

    case 200:
      return '#FECACA';

    case 300:
      return '#FCA5A5';

    case 400:
      return '#F87171';

    case 500:
      return '#EF4444';

    case 600:
      return '#BF3636';

    case 700:
      return '#8F2929';

    case 800:
      return '#601B1B';

    case 900:
      return '#300E0E';

    case 950:
      return '#180707';

    default:
      return '#EF4444';
  }
};

export const base = (number = 500) => {
  switch (number) {
    case 50:
      return '#E8E9EC';

    case 100:
      return '#D1D3D8';

    case 200:
      return '#A3A7B1';

    case 300:
      return '#757A8B';

    case 400:
      return '#474E64';

    case 500:
      return '#19223D';

    case 600:
      return '#141B31';

    case 700:
      return '#0F1425';

    case 800:
      return '#0A0E18';

    case 900:
      return '#05070C';

    case 950:
      return '#05070C';

    default:
      return '#19223D';
  }
};

export const black = '#000000';
export const white = '#FFFFFF';
export const grey = '#B1B1B1';
export const coldBlue = '#2FC3CA';

export function forSeverity(severity) {
  switch (severity) {
    case 'Critical':
      return error;
    case 'Warning':
      return warning;
    default:
      return accent;
  }
}
